import { classNames } from "@/react/helpers/twMergeWithCN";
import type { CommunityMember } from "@/react/types/CommunityMember";
import { useDetermineConnectionStatus } from "../hooks/useDetermineConnectionStatus";
import { useIsCurrentUser } from "../hooks/useIsCurrentUser";
import { ConnectButton } from "./ConnectButton";
import { IgnoreAccept } from "./IgnoreAccept";
import { MessageButton } from "./MessageButton";
import { PendingButton } from "./PendingButton";

export const ConnectionButtons = ({
  member,
  className,
  shouldShowOnlyIcon,
}: {
  member: CommunityMember;
  className?: string;
  shouldShowOnlyIcon?: boolean;
}) => {
  const isCurrentUser = useIsCurrentUser(member);

  const {
    isActive,
    isEmpty,
    isCurrentUserSentConnection,
    isOtherUserSentConnection,
  } = useDetermineConnectionStatus(
    member.connection_to_current_community_member,
  );

  if (isCurrentUser) {
    return null;
  }

  return (
    <div className={classNames("flex w-fit flex-col", className)}>
      {(function ConnectionButtons() {
        if (isActive) {
          return (
            <MessageButton
              member={member}
              shouldShowOnlyIcon={shouldShowOnlyIcon}
            />
          );
        }

        if (isCurrentUserSentConnection) {
          return (
            <PendingButton
              connectionId={member.connection_to_current_community_member?.id?.toString()}
              recipient={
                member.connection_to_current_community_member?.recipient.name ||
                ""
              }
              memberPublicUid={member.public_uid}
            />
          );
        }

        if (isEmpty) {
          return <ConnectButton recipient={member} />;
        }

        if (isOtherUserSentConnection) {
          return (
            <IgnoreAccept
              recipient={member}
              connectionId={member.connection_to_current_community_member?.id?.toString()}
            />
          );
        }

        return null;
      })()}
    </div>
  );
};
